var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRedo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1028.3622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.5 1031.8622 6 7.5-6 7.5v-5h-5c-2.693494 2.6067-.970927 5 2 5v2c-3.407831 0-8-1.3157-8-7.5 0-2.1042 1.725463-4.5 6-4.5h5z",
    fill: "#8cbe8c",
    fillRule: "evenodd",
    stroke: "#639563",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 1031.8622 6 7.5-6 7.5v-5h-5c-2.693494 2.6067-.970927 5 2 5v2c-3.407831 0-8-1.3157-8-7.5 0-2.1042 1.725463-4.5 6-4.5h5z",
    fill: "none",
    stroke: "#639563",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redo.d654267d.svg";
export { ForwardRef as ReactComponent };